<ng-container>
  <h2 mat-dialog-title>
    Model Version Comparison
    <mat-spinner mode="indeterminate" *ngIf="inProgress" diameter="20"></mat-spinner>
  </h2>
  <mat-dialog-content class="mat-typography">
    <div class="comparison-summary" *ngIf="!inProgress">
      <div class="version-card version-card-left">
        <div class="version-label">Left version</div>
        <div class="version-title">{{ leftVersionLabel }}</div>
      </div>
      <div class="comparison-stats">
        <div class="stat-item stat-modified">
          <span class="stat-value">{{ summary.modified }}</span>
          <span class="stat-label">Modified</span>
        </div>
        <div class="stat-item stat-added">
          <span class="stat-value">{{ summary.added }}</span>
          <span class="stat-label">Added</span>
        </div>
        <div class="stat-item stat-deleted">
          <span class="stat-value">{{ summary.deleted }}</span>
          <span class="stat-label">Deleted</span>
        </div>
        <div class="stat-item stat-unchanged">
          <span class="stat-value">{{ summary.unchanged }}</span>
          <span class="stat-label">Unchanged</span>
        </div>
      </div>
      <div class="version-card version-card-right">
        <div class="version-label">Right version</div>
        <div class="version-title">{{ rightVersionLabel }}</div>
      </div>
    </div>

    <div class="status-legend" *ngIf="!inProgress">
      <span class="legend-pill legend-modified">Modified</span>
      <span class="legend-pill legend-added">Added</span>
      <span class="legend-pill legend-deleted">Deleted</span>
      <span class="legend-pill legend-unchanged">Unchanged</span>
    </div>

    <div class="comparison-scrollbar" *ngIf="!inProgress" #comparisonScrollbar (scroll)="syncComparisonScroll('top')">
      <div class="comparison-scrollbar-spacer" [style.width.px]="comparisonTableScrollWidth"></div>
    </div>

    <div class="comparison-table-container" #comparisonTableContainer (scroll)="syncComparisonScroll('table')">
      <table mat-table [dataSource]="fileComparisons" class="mat-elevation-z8 comparison-table" aria-labelledby="compare models" #comparisonTable>
          <ng-container matColumnDef="idx">
            <th mat-header-cell *matHeaderCellDef> No.</th>
            <td mat-cell *matCellDef="let comparison"> {{comparison.idx}} </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let comparison">
              <span class="row-status" [ngClass]="comparison.changeType">{{ comparison.changeType }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="leftName">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let comparison" [ngClass]="getCellClasses(comparison, 'left')">
              <button *ngIf="comparison.changeType === 'modified' && comparison.comparisonViewable;else content" mat-button color="warn"
                      (click)="onCompareFileVersions(comparison.leftName, comparison.leftFileId, comparison.rightFileId)">{{comparison.leftName}}</button>
              <ng-template #content>{{comparison.leftName}}</ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="leftFolder">
            <th mat-header-cell *matHeaderCellDef> Path </th>
            <td mat-cell *matCellDef="let comparison" [ngClass]="getCellClasses(comparison, 'left')"> {{comparison.leftFolder}} </td>
          </ng-container>

          <ng-container matColumnDef="leftSize">
            <th mat-header-cell *matHeaderCellDef> Size </th>
            <td mat-cell *matCellDef="let comparison" [ngClass]="getCellClasses(comparison, 'left')"> {{comparison.leftSize  | number: '1.0-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="leftDate">
            <th mat-header-cell *matHeaderCellDef> Modified On </th>
            <td mat-cell *matCellDef="let comparison" [ngClass]="getCellClasses(comparison, 'left')"> {{comparison.leftDate | date: 'mediumDate'}} </td>
          </ng-container>

          <ng-container matColumnDef="rightName">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let comparison" [ngClass]="getCellClasses(comparison, 'right')">
              <button *ngIf="comparison.changeType === 'modified' && comparison.comparisonViewable;else content" mat-button color="warn"
                      (click)="onCompareFileVersions(comparison.rightName, comparison.leftFileId, comparison.rightFileId)"
              >{{comparison.rightName}}</button>
              <ng-template #content>{{comparison.rightName}}</ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="rightFolder">
            <th mat-header-cell *matHeaderCellDef> Path </th>
            <td mat-cell *matCellDef="let comparison" [ngClass]="getCellClasses(comparison, 'right')"> {{comparison.rightFolder}} </td>
          </ng-container>

          <ng-container matColumnDef="rightSize">
            <th mat-header-cell *matHeaderCellDef> Size </th>
            <td mat-cell *matCellDef="let comparison" [ngClass]="getCellClasses(comparison, 'right')"> {{comparison.rightSize | number: '1.0-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="rightDate">
            <th mat-header-cell *matHeaderCellDef> Modified On </th>
            <td mat-cell *matCellDef="let comparison" [ngClass]="getCellClasses(comparison, 'right')"> {{comparison.rightDate | date: 'mediumDate'}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr  mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="row.type"></tr>
      </table>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" *ngIf="!inProgress">
    <button mat-raised-button mat-dialog-close color="warn">Close</button>
  </mat-dialog-actions>
</ng-container>
